import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import LeadersIndex from '@/views/leaders/index.vue'

const leadersRoutes: RouteRecordRaw[] = [
  {
    path: '/leaders',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [{ path: '', name: 'Leaders', component: LeadersIndex }],
  },
]

export default leadersRoutes
